module.exports = __webpack_public_path__ + "static/media/hamburger.753e6ec8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/hamburger.svg
// module id = 476
// module chunks = 0